<template>
  <div class="computer-home-page">
    <div class="nav-page-box">
      <nav-page-view
        :tabHoverPage="0"
      ></nav-page-view>
    </div>
    <div class="banner-page-box" v-if="bannerList.length">
      <banner-page-view
        :bannerList="bannerList"
      ></banner-page-view>
    </div>
    <div class="company-profile">
      <title-page-view
        :titleObj="companyProfileObj"
      ></title-page-view>
      <div class="company-profile-content flex-middle-x layout-flex-justify-content_space-between">
        <div>
          <p class="title">上海<span>金保证</span>网络科技有限公司</p>
          <p class="content">Shanghai golden guarantee network technology co. LTD</p>
          <h5>上海金保证网络科技有限公司，地处上海漕河泾开发区，公司主力产品“斗票网”
            全国首家真正电影比价购票平台，主流电影票购票平台，实现轻松购票、快乐购票；
            “约车吧”是创新性聚合出行产品，实现多平台一键叫车、在线比价等功能，
            目前C端APP有百万级用户，B端与浦发、工商、交通、建设、北京、光大、
            中国等银行已深度合作。为企业客户提供高稳定性、高拓展性的产品，
            目前已拥有多项自主研发的技术方案。</h5>
          <img :src="companyProfileContent" alt="">
        </div>
        <img :src="companyProfileImage" alt="">
      </div>
    </div>
    <div class="computer-image">
      <img :src="computerImage" alt="">
    </div>
    <div class="service-process">
      <title-page-view
        :titleObj="serviceProcessObj"
      ></title-page-view>
    </div>
    <div class="service-box">
      <ul class="flex-middle-x layout-flex-center">
        <li v-for="(item,index) in serviceList">
          <img :src="item.image" alt="">
          <h4>{{item.title}}</h4>
          <p>{{item.content}}</p>
        </li>
      </ul>
    </div>
    <div class="service-advantage">
      <title-page-view
        :titleObj="serviceAdvantageObj"
      ></title-page-view>
    </div>
    <div class="service-advantage-content flex-middle-x layout-flex-center">
      <ul class="flex-middle-x">
        <li v-for="(item,index) in ServiceAdvantageList">
          <img :src="item.image" alt="">
          <div>
            <h3>{{item.title}}</h3>
            <hr>
            <p>{{item.content}}</p>
          </div>
        </li>
      </ul>
    </div>
    <div class="memorabilia">
      <title-page-view
        :titleObj="memorabiliaObj"
      ></title-page-view>
      <div class="memorabilia-content">
        <ul class="memorabilia-tab">
          <li class="two-thousand-sixteen" @click="actionClickMemorabilia(0)">
            <img :src="twoThousandSixteenImage" alt="">
          </li>
          <li class="two-thousand-seventeen" @click="actionClickMemorabilia(1)">
            <img :src="twoThousandSeventeenImage" alt="">
          </li>
          <li class="two-thousand-eighteen" @click="actionClickMemorabilia(2)">
            <img :src="twoThousandEighteenImage" alt="">
          </li>
        </ul>
        <div class="cooperation-sixteen" v-if="memorabiliaIndex === 0">
          <div class="up-content flex-middle-x">
            <div v-for="(item,index) in cooperationUpSixteen">
              <p>{{item.name}}</p>
              <span>{{item.content}}</span>
            </div>
          </div>
          <ul class="up flex-middle-x">
            <li v-for="(item,index) in cooperationUpSixteen">
              <img :src="cooperationImage" alt="">
            </li>
          </ul>
          <ul class="down flex-middle-x layout-flex-justify-content_space-between">
            <li v-for="(item,index) in cooperationDownSixteen">
              <img :src="cooperationImageDown" alt="">
            </li>
          </ul>
          <div  class="down-content flex-middle-x layout-flex-justify-content_space-between">
            <div v-for="(item,index) in cooperationDownSixteen">
              <span>{{item.content}}</span>
              <p>{{item.name}}</p>
            </div>
          </div>
        </div>
        <div class="cooperation-seventeen" v-if="memorabiliaIndex === 1">
          <div class="up-content flex-middle-x">
            <div v-for="(item,index) in cooperationUpSeventeen">
              <p>{{item.name}}</p>
              <span>{{item.content}}</span>
            </div>
          </div>
          <ul class="up flex-middle-x">
            <li v-for="(item,index) in cooperationUpSeventeen">
              <img :src="cooperationImage" alt="">
            </li>
          </ul>
          <ul class="down flex-middle-x layout-flex-justify-content_space-between">
            <li v-for="(item,index) in cooperationDownSeventeen">
              <img :src="cooperationImageDown" alt="">
            </li>
          </ul>
          <div  class="down-content flex-middle-x layout-flex-justify-content_space-between">
            <div v-for="(item,index) in cooperationDownSeventeen">
              <span>{{item.content}}</span>
              <p>{{item.name}}</p>
            </div>
          </div>
        </div>
        <div class="cooperation-eighteen" v-if="memorabiliaIndex === 2">
          <div class="up-content flex-middle-x">
            <div v-for="(item,index) in cooperationUpEighteen">
              <p>{{item.name}}</p>
              <span>{{item.content}}</span>
            </div>
          </div>
          <ul class="up flex-middle-x">
            <li v-for="(item,index) in cooperationUpEighteen">
              <img :src="cooperationImage" alt="">
            </li>
          </ul>
          <ul class="down flex-middle-x layout-flex-justify-content_space-between">
            <li v-for="(item,index) in cooperationDownEighteen">
              <img :src="cooperationImageDown" alt="">
            </li>
          </ul>
          <div  class="down-content flex-middle-x layout-flex-justify-content_space-between">
            <div v-for="(item,index) in cooperationDownEighteen">
              <span>{{item.content}}</span>
              <p>{{item.name}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="contact-way-box">
      <div class="contact-way">
        <h5>金保证邀您共铸辉煌</h5>
        <p class="content">您只需提交，剩下的工作交给我们</p>
        <div class="phone-mail flex-middle-x layout-flex-center">
          <span class="phone flex-middle-x"><img :src="phoneImage" alt="">021-61921322</span>
          <span class="mail flex-middle-x"><img :src="mailImage" alt="">pengdashuai@jinbaozheng.com</span>
        </div>
        <div class="input-area flex-middle-x layout-flex-justify-content_space-between">
          <input type="text" v-model="inputName"  placeholder="姓名">
          <input type="tel"  v-model="inputPhone" placeholder="手机" maxlength="11">
          <input type="email" v-model="inputEmail"  placeholder="邮箱">
        </div>
        <textarea name="" id="" cols="30" rows="10"
                  placeholder="留言"
                  v-model="guestBook"
        ></textarea>
        <br>
        <button @click="actionClickSubmit">
          <a :href="submitObj">提交</a>
        </button>
      </div>
    </div>
    <div class="footer-page-box">
      <footer-page-view
      ></footer-page-view>
    </div>
  </div>
</template>
<script>
  import BannerPageView from '@/components/computer/home/BannerPageView.vue'
  export default {
    name:'',
    data(){
      return {
        isReg:false,
        regPhone: /^1[0-9][0-9]{9}$/,
        /* eslint-disable */
        regMail:/[\w\$%&\*]{3,32}@[A-Za-z0-9]{2,16}(\.[a-z\u4e00-\u9fa5]{2,8})+$/,
        /* eslint-disable */
        inputName:'',
        inputPhone:null,
        inputEmail:'',
        guestBook:'',
        companyProfileObj:{
          mainHeading:'company profile',
          subhead:'公司简介',
          content:'“为客户创造价值”'
        },
        serviceProcessObj:{
          mainHeading:'Service process',
          subhead:'我们的服务流程',
          content:'“按需求定制最优框架，提供简单易用操作体验，交付满意服务成果”'
        },
        serviceAdvantageObj:{
          mainHeading:'Service advantage',
          subhead:'我们的服务优势',
          content:'“创意，流程，执行缺一不可”'
        },
        memorabiliaObj:{
          mainHeading:'memorabilia',
          subhead:'大事记',
          content:''
        },
        computerImage:require('./image/computer-image.jpg'),
        phoneImage:require('./image/phone-image.png'),
        mailImage:require('./image/mail-image.png'),
        companyProfileContent:require('./image/company-profile-content-image.png'),
        companyProfileImage:require('./image/company-profile-image.png'),
        cooperationImage:require('./image/cooperation-image.png'),
        cooperationImageDown:require('./image/cooperation-image-down.png'),
        memorabiliaIndex:0
      }
    },
    components:{
      'banner-page-view':BannerPageView
    },
    computed:{
      submitObj(){
        if (this.isReg){
          return 'Mailto:pengdashuai@jinbaozheng.com?CC=' + '&Subject=' + this.guestBook +
          '&Body=姓名：' + this.inputName + ' 手机号：' + this.inputPhone + ' 邮箱：' +
            this.inputEmail + ' 留言：' + this.guestBook;
        } else {
          return 'javascript:void(0)';
        }
      },
      bannerList(){
        return [
          {imgUrl:require('./image/banner.jpg'),
            banner:require('./image/banner1-image.png'),
            title:'我们只做态度的执行者',
            content:'寻求资源配置，客户需求最佳结合点。实现1+1大于2',
            introduce:''
          },
          {imgUrl:require('./image/banner.jpg'),
            banner:require('./image/banner2-image.png'),
            title:'提供以客户需求为导向',
            content:'针对项目不同内容，采取不同的方法协助企业实施落地',
            introduce:''},
          {imgUrl:require('./image/banner.jpg'),
            banner:require('./image/banner3-image.png'),
            title:'以客户为中心，用心服务客户',
            content:'技术和人才的整合，为行业跟随者提供最佳实践',
            introduce:'为客户提供卓越的服务体验'}
        ]
      },
      serviceList(){
        return [
          {image:require('./image/service1.png'), title:'需求分析', content:'需求分析师前期市场调研分析'},
          {image:require('./image/service2.png'), title:'设计规划', content:'功能，架构设计，逻辑思维图'},
          {image:require('./image/service3.png'), title:'设计实施', content:'交互，视觉设计，用户体验设计'},
          {image:require('./image/service4.png'), title:'项目跟进', content:'前端工程师，后端开发优化'},
          {image:require('./image/service5.png'), title:'测试压测', content:'测试工程师压力测试，优化跟新'},
          {image:require('./image/service6.png'), title:'成果检验', content:'产品上线，运营，迭代设计'}
        ]
      },
      ServiceAdvantageList(){
        return [
          {
            image:require('./image/quality-image.png'),
            title:'专及注品质追求',
            content:'从创始至今，我们的业务方向始终不变，专注做好一件事才能更好的追求高品质，' +
            '这也是金保证存在的价值。\n' +
          '在未来我们也是基于此信念而继续创造。 '},
          {
            image:require('./image/project-procedures-image.png'),
            title:'严谨的项目流程',
            content:'在不断的创新和实践中总结出可持续和可信赖的设计流程，坚持与用户一起思考，' +
            '用设计的方法发现问题、\n' +
          '解决问题、输出设计方案，并实现客户产品和企业价值的提升。'},
          {
            image:require('./image/accumulation-project-image.png'),
            title:'优秀的项目积累',
            content:'金保证积累了大量优秀的项目案例，并验证了设计的价值。在不断的探索中总结经验，' +
            '以结果为导向，继续\n' +
          '为更多客户提供优秀的设计优质项目。'}
        ]
      },
      twoThousandSixteenImage(){
        if (this.memorabiliaIndex === 0){
          return require('./image/2016true.png');
        } else {
          return require('./image/2016false.png');
        }
      },
      twoThousandSeventeenImage(){
        if (this.memorabiliaIndex === 1){
          return require('./image/2017true.png');
        } else {
          return require('./image/2017false.png');
        }
      },
      twoThousandEighteenImage(){
        if (this.memorabiliaIndex === 2){
          return require('./image/2018true.png');
        } else {
          return require('./image/2018false.png');
        }
      },
      cooperationUpSixteen(){
        return [
          {name:'网票达成战略合作', content:'(2016.1)'},
          {name:'卖座达成战略合作', content:'(2016.9)'}
        ]
      },
      cooperationDownSixteen(){
        return [
          {name:'浦发银行达成战略合作', content:'(2016.8)'},
          {name:'猫眼达成战略合作', content:'(2016.12)'}
        ]
      },
      cooperationUpSeventeen(){
        return [
          {name:'糯米达成战略合作', content:'(2017.1)'},
          {name:'京东达成战略合作', content:'(2017.3)'},
          {name:'工商银行达成战略合作', content:'(2017.07)'},
          {name:'交行手机银行', content:'(2017.12)'}
        ]
      },
      cooperationDownSeventeen(){
        return [
          {name:'买单吧达成战略合作', content:'(2017.1)'},
          {name:'淘票票达成战略合作', content:'(2017.7)'},
          {name:'民生银行达成战略合作', content:'(2017.09)'},
          {name:'江苏农行达成战略合作', content:'(2017.12)'}
        ]
      },
      cooperationUpEighteen(){
        return [
          {name:'平安银行达成战略合作', content:'(2018.02)'},
          {name:'华夏银行达成战略合作', content:'(2018.03)'},
          {name:'建设银行达成战略合作', content:'(2018.07)'}
        ]
      },
      cooperationDownEighteen(){
        return [
          {name:'光大银行达成战略合作', content:'(2018.02)'},
          {name:'北京银行达成战略合作', content:'(2018.04)'},
          {name:'广发银行达成战略合作', content:'(2018.10)'}
        ]
      }
    },
    methods:{
      actionClickSubmit(){
        if (!this.inputName){
          window.alert('姓名不可以为空');
          return;
        }
        if (!this.inputPhone){
          window.alert('手机不可以为空');
          return;
        }
        if (!this.inputEmail){
          window.alert('邮箱不可以为空');
          return;
        }
        if (!this.guestBook){
          window.alert('留言版不可以为空');
          return;
        }
        if (!this.regPhone.test(this.inputPhone)){
          window.alert('电话格式不正确');
          return;
        }
        if (!this.regMail.test(this.inputEmail)){
          window.alert('邮箱格式不正确');
        }
        this.isReg = true;
      },
      actionClickMemorabilia(index){
        this.memorabiliaIndex = index;
      },
      setAnimated(){
        let bodys = document.getElementsByTagName('body');
        let serviceProcess = document.querySelector('.service-process');
        window.onscroll = () => {
          if (bodys[0].scrollTop > (serviceProcess.offsetTop - document.body.clientWidth - 200)) {
            serviceProcess.className = 'animated fadeInDown';
          }
        }
      }
    },
    mounted(){
//      this.setAnimated();
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss" scoped="">
  .computer-home-page{
    width:100%;
    min-width:1200px;
    background:#f8fbfd;
    .nav-page-box{
      width:100%;
    }
    .banner-page-box{
      width:100%;
      background:#040719;
    }
    .company-profile{
      background:$color-4;
      padding-bottom:20px;
      .company-profile-content{
        width:1200px;
        margin:80px auto;
        div{
          text-align: left;
          position: relative;
          .title{
            font-size:30px;
            color:#333333;
            span{
              color:#ffbd1f;
            }
          }
          .content{
            font-size:22px;
            color:#555555;
          }
          h5{
            width:460px;
            font-size:16px;
            color:#555555;
            line-height:28px;
            position: absolute;
            text-align: justify;
            top:120px;left:10px;
          }
          img{
            width:480px;
            margin-top:20px;
          }
        }
        img{
          width:480px;
        }
      }
    }
    .service-process{
      background:$color-4;
    }
    .service-box{
      width:100%;
      background:$color-4;
      ul{
        width:1200px;
        margin:auto;
        flex-wrap: wrap;
        background:url('./image/service-process-background.jpg');
        background-size:100% 90%;
        li{
          width:390px;
          padding:90px;
          img{
            width:90px;
            padding-left:20px;
            position: relative;
            top:-15px;
          }
          h4{
            font-size:16px;
            color:#333333;
            white-space: normal;
          }
          p{
            font-size:14px;
            color:#555555;
            white-space: normal;
          }
        }
      }
    }
    .computer-image{
      width:100%;
      img{
        width:100%;
      }
    }
    .service-advantage{
      background:#f8fbfd;
    }
    .service-advantage-content{
      width:100%;
      background:#f8fbfd;
      ul{
        max-width:1200px;
        margin: auto;
        text-align: center;
        li{
          width:368px;
          height:362px;
          margin-top:30px;
          border:1px solid $color-d;
          margin-left:30px;
          padding:0 20px;
          background:$color-4;
          cursor: pointer;
          hr{
            width:80px;
            height:2px;
            background:#ffc438;
            border:none;
          }
          img{
            width:95px;
            margin-top:30px;
          }
          div{
            h3{
              font-size:22px;
              color: $color-black;
              margin-top:20px;
            }
            p{
              font-size:16px;
              color:$color-3;
              text-align: justify;
              word-break: break-all;
              margin-top:20px;
            }
          }
          &:hover{
            box-shadow: 1px 0 10px #cccccc;
          }
        }
      }
    }
    .memorabilia{
      background: $color-4;
      margin-top:60px;
      padding-bottom:100px;
      .memorabilia-content{
        width:100%;
        .memorabilia-tab{
          width:1200px;
          height:100px;
          background:url('./image/experience.png') repeat-x;
          margin:80px auto;
          position: relative;
          li{
            width:100px;
            position: absolute;
            top:-30px;
            cursor: pointer;
            img{
              width:100%;
            }
          }
          .two-thousand-sixteen{
            left:100px;
          }
          .two-thousand-seventeen{
            left:520px;
          }
          .two-thousand-eighteen{
            left:940px;
          }
        }
        .cooperation-sixteen{
          width:1200px;
          margin:auto;
          .up{
            border-bottom:1px solid #d8d8d8;
            position: relative;
            margin-top:15px;
            li{
              width:100px;
              position: relative;
              top:10px;
              margin-right:150px;
              padding-right:500px;
            }
          }
          .down{
            position: relative;
            margin-top:15px;
            padding-left:400px;
            li{
              width:200px;
              position: relative;
              top:-25px;
              margin-right:100px;
            }
          }
          .up-content{
            margin:15px 0;
            text-align: left;
            div{
              padding-right:450px;
              span{
                font-size:18px;
                color:#ffc438;
              }
              p{
                width:200px;
                font-size:16px;
                color:#696969;
              }
            }
          }
          .down-content{
            margin:15px 0;
            text-align: left;
            padding-left:450px;
            div{
              padding-right:20px;
              span{
                font-size:18px;
                color:#ffc438;
              }
              p{
                font-size:16px;
                color:#696969;
                width:200px;
              }
            }
          }
        }
        .cooperation-seventeen{
          width:1200px;
          margin:auto;
          .up{
            border-bottom:1px solid #d8d8d8;
            position: relative;
            margin-top:15px;
            li{
              width:100px;
              position: relative;
              top:10px;
              margin-right:50px;
              padding-right:250px;
            }
          }
          .down{
            position: relative;
            margin-top:15px;
            padding-left:200px;
            li{
              width:200px;
              position: relative;
              top:-25px;
              margin-left:-150px;
            }
          }
          .up-content{
            margin:15px 0;
            text-align: left;
            div{
              padding-right:100px;
              span{
                font-size:18px;
                color:#ffc438;
              }
              p{
                width:200px;
                font-size:16px;
                color:#696969;
              }
            }
          }
          .down-content{
            margin:15px 0;
            text-align: left;
            padding-left:130px;
            div{
              padding-right:20px;
              span{
                font-size:18px;
                color:#ffc438;
              }
              p{
                font-size:16px;
                color:#696969;
                width:200px;
              }
            }
          }
        }
        .cooperation-eighteen{
          width:1200px;
          margin:auto;
          .up{
            border-bottom:1px solid #d8d8d8;
            position: relative;
            margin-top:15px;
            li{
              width:100px;
              position: relative;
              top:10px;
              margin-right:50px;
              padding-right:350px;
            }
          }
          .down{
            position: relative;
            margin-top:15px;
            padding-left:120px;
            li{
              width:200px;
              position: relative;
              top:-25px;
              margin-right:100px;
            }
          }
          .up-content{
            margin:15px 0;
            text-align: left;
            div{
              padding-right:180px;
              span{
                font-size:18px;
                color:#ffc438;
              }
              p{
                width:200px;
                font-size:16px;
                color:#696969;
              }
            }
          }
          .down-content{
            margin:15px 0;
            text-align: left;
            padding-left:150px;
            div{
              padding-right:20px;
              span{
                font-size:18px;
                color:#ffc438;
              }
              p{
                font-size:16px;
                color:#696969;
                width:200px;
              }
            }
          }
        }
      }
    }
    .contact-way-box{
      width:100%;
      background:url('./image/contact-way-image.jpg');
      background-size:100% 100%;
      padding-top:50px;
      .contact-way{
        max-width:1200px;
        height:100%;
        margin:auto;
        color:$color-4;
        h5{
          font-size:48px;
        }
        .content{
          font-size:24px;
          margin-top:10px;
        }
        .phone-mail{
          margin-top:20px;
          padding:20px 0;
          border-top:1px solid $color-d;
          border-bottom:1px solid $color-d;
          img{
            width:60px;
            padding-right:30px;
          }
          span{
            font-size:36px;
          }
          .mail{
            padding-left:100px;
          }
        }
        .input-area{
          width:1200px;
          margin-top:30px;
          input{
            width:368px;
            height:43px;
            padding-left:10px;
            font-size:16px;
            color:#a8a8a8;
          }
        }
      }
      textarea{
        width:1200px;
        height:150px;
        font-size:16px;
        color:#a8a8a8;
        margin-top:40px;
        outline: none;
        cursor: pointer;
      }
      button{
        width:191px;
        height:44px;
        border:2px solid #ffbd1f;
        background:transparent;
        margin:50px 0;
        a{
          width:100%;
          color:#ffbd1f;
          font-size:16px;
        }
        &:hover{
          border:1px solid transparent;
          background:#ffbd1f;
          a{
            color:$color-4;
          }
        }
      }
    }
    .footer-page-box{
      width:100%;
    }
  }
</style>
